<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-listar #ctrl URL="plan-estudio" titulo="Plan de estudio / Coordinación escolar"></app-listar>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside ></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- Opciones y busqueda -->
            <app-tabla-opciones [ctrl]="ctrl"></app-tabla-opciones>

            <span id="exportar_datos" style="overflow-y:auto; overflow-x: hidden; display:block; height: 79vh;">

                <!--Tabla -->
                <table class="table is-striped is-fullwidth" *ngIf="ctrl.tipo_grid && !ctrl.cargando ">
                    <thead>
                        <tr>
                            <th><abbr>ID</abbr></th>
                            <th>Nombre</th>
                            <th>Activo</th>
                            <th>Creado</th>
                            <th>Actualizado</th>
                            <th width="1%">Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of ctrl.dato; let i=index">
                            <td style="vertical-align: middle;">{{ i + 1 }}</td>
                            <td style="vertical-align: middle;">{{ item.nombre }} </td>
                            <td style="vertical-align: middle;"> <span *ngIf="item.activo==1"> <i class="fa fa-circle fa-2x has-text-success"></i> </span> <span *ngIf="item.activo==0"> <i class="fa fa-circle fa-2x has-text-danger"></i> </span></td>
                            <td style="vertical-align: middle;">{{item.created_at}}</td>
                            <td style="vertical-align: middle;">{{item.updated_at}}</td>
                            <td style="vertical-align: middle;" class="has-text-centered">
                                <!-- acciones -->
                                <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                            </td>

                        </tr>
                        <tr *ngIf="ctrl.dato.length == 0">
                            <td colspan="6" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                        </tr>
                    </tbody>

                </table>

                <!--Lista -->
                <span *ngIf="!ctrl.tipo_grid && !ctrl.cargando">
                    <div class="box" *ngFor="let item of ctrl.dato; let i=index" style="margin-bottom:0.1rem;" [style.background]="i%2 == 0 ? '#fafafa' : '#ffffff'">
                        <article class="media">
                            <div class="media-left">
                            <figure class="image is-64x64">
                                <img src="./assets/128x128.png" alt="Image">
                            </figure>
                            </div>
                            <div class="media-content">
                                <div class="content">
                                    <p>
                                        <strong class="tag is-medium"> <small>ID: {{ i + 1 }}</small></strong>

                                        <strong class="tag is-medium">
                                            Nombre: {{ item.nombre }}
                                        </strong>

                                        <strong class="tag is-medium">
                                          <span *ngIf="item.activo==1"> <i class="fa fa-circle fa-2x has-text-success"></i> </span>
                                          <span *ngIf="item.activo==0"> <i class="fa fa-circle fa-2x has-text-danger"></i> </span>
                                        </strong>

                                        <strong class="tag is-medium">
                                            Creado: {{ item.created_at }}
                                        </strong>

                                        <strong class="tag is-medium">
                                            Actualizado: {{ item.updated_at }}
                                        </strong>

                                    </p>
                                </div>
                                <nav class="level is-mobile" style="float:right">
                                    <div class="level-left">

                                        <!-- acciones -->
                                        <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                                    </div>
                                </nav>
                            </div>
                        </article>
                    </div>
                </span>
            </span>
            <!-- Paginación para la lista  -->
            <app-paginacion [ctrl]="ctrl"></app-paginacion>

        </div>
    </div>
</div>
